import { Component, Inject } from "@angular/core"
import { CommonModule } from "@angular/common"
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog"
import { MatButtonModule } from "@angular/material/button"
import { MatIconModule } from "@angular/material/icon"
import { MatChipsModule } from "@angular/material/chips"
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner"

import { LockoutService } from "../../services/lockout.service"
import { SnackbarService } from "../../services/snackbar.service"
import { ConfirmDialogService } from "../../services/confirm-dialog.service"

export interface LockedDatesListDialogData {
  stationId: number
  dates: string[]
}

@Component({
  selector: "app-locked-dates-list-dialog",
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatChipsModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: "./locked-dates-list-dialog.component.html",
  styleUrl: "./locked-dates-list-dialog.component.css",
})
export class LockedDatesListDialogComponent {
  dates: string[]
  unlockingDate: string | null = null

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: LockedDatesListDialogData,
    private dialogRef: MatDialogRef<LockedDatesListDialogComponent>,
    private lockoutService: LockoutService,
    private snackbar: SnackbarService,
    private confirmDialog: ConfirmDialogService,
  ) {
    this.dates = [...(data.dates || [])]
  }

  close(): void {
    this.dialogRef.close({ refreshed: true })
  }

  unlockDate(iso: string, event?: Event): void {
    event?.stopPropagation()
    if (this.unlockingDate) return

    this.confirmDialog
      .open({
        title: "Unlock schedule date",
        message: `Are you sure you want to unlock ${iso}? Schedules become editable and orders can use this start date again.`,
        confirmLabel: "Unlock",
        cancelLabel: "Cancel",
      })
      .subscribe((ok) => {
        if (!ok) return
        this.unlockingDate = iso
        this.lockoutService.unlockScheduleDay(this.data.stationId, { date: iso }).subscribe({
          next: (res) => {
            this.unlockingDate = null
            if (res.unlocked) {
              this.dates = res.lockedDates || []
              this.snackbar.success(
                `Unlocked ${iso}. Removed ${res.promosRemoved} auto-filled promo(s).`,
                5000,
              )
              if (this.dates.length === 0) {
                this.dialogRef.close({ refreshed: true })
              }
            } else {
              this.snackbar.info("This date was not locked.", 4000)
            }
          },
          error: (err) => {
            this.unlockingDate = null
            this.snackbar.error(err?.error?.error || "Failed to unlock date", 5000)
          },
        })
      })
  }
}
